import { LocaleType } from './core/interfaces/locale-type.interface';
import { en_US, es_ES } from 'ng-zorro-antd/i18n';
import { enUS, es } from 'date-fns/locale';
import { OxioLocaleCode } from './core/enums';

const locales: LocaleType[] = [
  // English should always be first
  {
    label: 'English',
    code: 'en',
    ngZorroCode: en_US,
    dateFnsCode: enUS,
    oxioCode: OxioLocaleCode.en_US,
  },
  {
    label: 'Español',
    code: 'es-MX',
    ngZorroCode: es_ES,
    dateFnsCode: es,
    oxioCode: OxioLocaleCode.es_MX,
  },
];

export { locales };
